import React from 'react';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';

import BottomComment from './BottomComment';
import CommentPendant from './CommentPendant';
import { observable, action } from 'mobx';
import commentApi from '../../actions/comment';
import stat from '../../utils/stat';

@inject('rootStore')
@observer
class CommentWrapper extends React.Component {
  @observable listGet = false;
  getAllList = () => {
    let task = [this.getTopList(), this.getList()];
    return Promise.all(task).then(
      action(() => {
        this.listGet = true;
      })
    );
  };
  componentDidMount() {
    this.getAllList();
    // this.getListTimer = setInterval(this.getList,10000);
  }
  componentWillUnmount() {
    // clearInterval(this.getListTimer);
    //清理各种数据
    const { commentStore } = this.props.rootStore;
    commentStore.clear();
  }

  getList = () => {
    return this.props.rootStore.commentStore.getList(this.props.galleryId);
  };
  getTopList = () => {
    return this.props.rootStore.commentStore.getTop(this.props.galleryId);
  };
  submitMyComment = content => {
    stat.event('event_comments');
    const { commentStore } = this.props.rootStore;
    return commentApi
      .post({ content, galleryid: this.props.galleryId })
      .then(jsonData => {
        // {id:XX}
        if (jsonData && jsonData.id) {
          this.props.rootStore.uiStore.showToast({
            content: intl.get('Success'),
            time: 1000
          });
          //后端正常返回后，直接用这个数据
          commentStore.addOne(jsonData);
          //commentStore.addOneMy(jsonData);
        } else {
          this.props.rootStore.uiStore.showToast({
            content: intl.get('Post Comment Error'),
            time: 1000
          });
        }
        return jsonData;
      });
  };
  deleteCommentById = id => {
    if (!id) {
      console.warn('no id in deleteCommentById');
      return;
    }
    const { commentStore } = this.props.rootStore;
    return commentApi.del(id).then(() => {
      this.props.rootStore.uiStore.showToast({
        content: intl.get('Delete') + intl.get('Success'),
        time: 1000
      });
      //直接重新获取自己的评论和所有人的评论，简单暴力
      // this.getList(true);
      // this.getMyList(true);
      //commentStore.deleteOneMyById(id);
      commentStore.deleteOneById(id);
    });
  };

  onSend = () => {
    this.props.setBottomComment(true);
  };

  render() {
    const { commentStore } = this.props.rootStore;
    if (!this.listGet) {
      return null;
    }
    return (
      <React.Fragment>
        <CommentPendant
          onSend={this.onSend}
          bottom={this.props.bottom}
          total={commentStore.sumTotal}
        />
        {this.props.showBottomComment ? (
          <BottomComment
            classNames={this.props.classNames}
            total={commentStore.sumTotal}
            list={commentStore.commentList}
            topList={commentStore.topCommentList}
            finished={commentStore.commentLoadAll}
            onDelete={this.deleteCommentById}
            getList={this.getList}
            submit={this.submitMyComment}
            close={this.props.setBottomComment.bind(this, false)}
            tab={this.props.tab}
            rootStore={this.props.rootStore}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default CommentWrapper;
